import React from "react";
import { Truck, Network } from "lucide-react";

import RhflDashboard from "./RhflDashboard";
import RmblDashboard from "./RmblDashboard";
import { ControlTowerPage } from "../OceanTMS/oceanDashboardUi";

function RoadDashboard({ embedded = false }) {
    return (
        <ControlTowerPage
            embedded={embedded}
            title="Road Operations Control Tower"
            subtitle="Active road shipments, operational risks and file performance in one view."
            tabs={[
                { label: "House Files (RHFL)", icon: Truck, component: <RhflDashboard /> },
                { label: "Master Files (RMBL)", icon: Network, component: <RmblDashboard /> },
            ]}
        />
    );
}

export default RoadDashboard;
